// Copyright 2026. WebPros International GmbH. All rights reserved.

import {
    api,
    IApiResponse,
} from 'common/api/resources/Response';
import {
    IMassMailUsersRequest,
    IMassMailingPreviewRequest,
    IMassMailingPreviewResponse,
} from 'common/api/resources/MassMailing';

export const massMailing = {
    post: (data: IMassMailUsersRequest) => api.post('/mass-mailing', {
        ...data,
    }),
    preview: (data: IMassMailingPreviewRequest) => api.post<IApiResponse<IMassMailingPreviewResponse>>('/mass-mailing/preview', {
        ...data,
    }),
};